


document.addEventListener("DOMContentLoaded", function() {
        
     function removeFromCart(...variantIds) {
        if (variantIds.length === 0) {
          console.warn('No variant IDs provided for removal. Nothing to do.');
          return Promise.resolve(true); 
        }
      
        const updates = {};
        variantIds.forEach(id => {
          if (typeof id === 'number' && id > 0) { 
            updates[id] = 0; 
          } else {
            console.warn(`Invalid variant ID provided: ${id}. Skipping.`);
          }
        });
      
        if (Object.keys(updates).length === 0) {
          console.warn('No valid variant IDs to remove after filtering. Nothing to do.');
          return Promise.resolve(true); 
        }
      
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: 'sections--25562165805401__cart-drawer'
          })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().catch(() => ({ message: response.statusText })) // Fallback if JSON parsing fails
              .then(errorData => {
                throw new Error(`Failed to remove items: ${errorData.message || 'Unknown error'}`);
              });
          }
          // If response is OK, proceed to the next .then()
          return response.json(); // Or just return response if you don't need the parsed JSON
        })
        .then(data => {

          
          document.querySelector("cart-count").innerText =  data.item_count;
          const txt = data.sections['sections--25562165805401__cart-drawer'];
          var targetElement = document.getElementById('cart-drawer');
          const parser = new DOMParser();
          const doc = parser.parseFromString(txt,'text/html');
          targetElement.innerHTML = doc.getElementById('cart-drawer').innerHTML;
          return true; // Indicate success
        })
        .catch(error => {
          console.error('Error removing items:', error);
          return false; // Indicate failure
        });
      }
    
    document.addEventListener("cart:change", function(event) {

              const product1ID = Number(document.querySelector('#product1')?.getAttribute('data-id'));
              const product2ID = Number(document.querySelector('#product2')?.getAttribute('data-id'));
              const freeGift1 = Number(document.querySelector('#free-gift1')?.getAttribute('data-free-gift1'));
              const freeGift2 = Number(document.querySelector('#free-gift2')?.getAttribute('data-free-gift2'));
              let product1InCart = false;
              let product2InCart = false;
              const inCart = { product1VarId: null, product2VarId: null };
        
              
              let cart = event.detail["cart"];
              let total_price = cart.total_price;
        
              cart.items.forEach((item)=>{
                if( item.product_id === product1ID){
                  product1InCart = true;
                  inCart.product1VarId = item.variant_id;
                }
                if( item.product_id === product2ID){
                  product2InCart = true;
                  inCart.product2VarId = item.variant_id;
                }
              });
      

      
              if( total_price < freeGift1 && product1InCart && product2InCart && inCart.product1VarId && inCart.product2VarId ){
                 
                   removeFromCart(inCart.product1VarId, inCart.product2VarId) // Assuming inCart is defined elsewhere
                      .then(success => {
                        if (success) {
                              console.log('remove first free gift success');
                              console.log('remvove second free gift success');
                              product1InCart = false;
                              product2InCart = false;
                        } else {
                              console.log('remove first free gift failed');
                              console.log('remvove second free gift failed');
                        }
                      })
                      .catch(error => {
                        // This catch block will only be hit if there's an unhandled error
                        // within the .then() chain itself, not from the fetch operation
                        console.error('An unexpected error occurred during removal process:', error);
                      });
                  
                  
              }
              else if( total_price < freeGift1 && product1InCart && inCart.product1VarId){
              //   alert('remove first item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product1VarId) // Assuming inCart is defined elsewhere
                  .then(success => {
                    if (success) {
                      console.log('remove first free gift success');
                       product1InCart = false;
                    } else {
                      console.log('remove first free gift failed');
                    }
                  })
                  .catch(error => {
                    console.error('An unexpected error occurred during removal process:', error);
                  });
                
               
              }
              else if( total_price < freeGift1 && product2InCart && inCart.product2VarId){
              //     alert('remove second item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product2VarId) // Assuming inCart is defined elsewhere
                    .then(success => {
                      if (success) {
                              console.log('remvove second free gift success');
                          product2InCart = false;
                      } else {
                       console.log('remvove second free gift failed');
                      }
                    })
                    .catch(error => {
                      console.error('An unexpected error occurred during removal process:', error);
                    });
               
                
              }
              else if( total_price < freeGift2 && total_price > freeGift1 && product2InCart && inCart.product2VarId){
              //   alert('remove second item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product2VarId) // Assuming inCart is defined elsewhere
                  .then(success => {
                    if (success) {
                      console.log('remvove second free gift success');
                      product2InCart = false;
                    } else {
                      console.log('remvove second free gift failed');
                    }
                  })
                  .catch(error => {
                    console.error('An unexpected error occurred during removal process:', error);
                  });
                
              }
              
          });
});
